import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, ChevronRight } from "lucide-react";
import api, { API_BASE } from "../../lib/api";

export default function ShopStrip() {
  const [cats, setCats] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/shop/public/home").then((r) => setCats(r.data.categories || [])).catch(() => {});
  }, []);
  const rows = useMemo(() => {
    const half = Math.ceil(cats.length / 2);
    return [cats.slice(0, half), cats.slice(half)];
  }, [cats]);
  if (!cats.length) return null;

  const Card = ({ c }) => {
    const imgProd = (c.sample_products || []).find((p) => p.has_image);
    const first = (c.sample_products || [])[0];
    return (
      <button onClick={() => navigate(`/shop?cat=${c.slug}`)} data-testid={`shop-strip-cat-${c.slug}`}
              className="group flex w-64 shrink-0 items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-saffron/40 hover:shadow-lg">
        <div className="flex min-w-0 items-center gap-3">
          {imgProd ? (
            <img src={`${API_BASE}/api/shop/public/image/${imgProd.id}`} alt={imgProd.name}
                 className="h-12 w-12 shrink-0 rounded-xl object-cover" data-testid={`shop-strip-img-${c.slug}`} />
          ) : (
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-saffron/10 text-saffron">
              <ShoppingBag className="h-5 w-5" />
            </span>
          )}
          <div className="min-w-0">
            <p className="truncate font-heading text-sm font-bold text-navy group-hover:text-saffron">{c.name}</p>
            <p className="mt-0.5 truncate text-[11px] text-slate-500">
              {first ? `from ₹${first.price} · ${first.name}` : c.subs?.length ? c.subs.slice(0, 3).join(" · ") : "Explore range"}
            </p>
          </div>
        </div>
        <ChevronRight className="h-4 w-4 shrink-0 text-slate-300 transition-colors group-hover:text-saffron" />
      </button>
    );
  };

  return (
    <section className="relative overflow-hidden bg-slate-50 py-14" data-testid="shop-strip">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-saffron">INDIAFAST BAZAAR</p>
            <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-navy sm:text-3xl">
              India's Bazaar, IndiaFast Delivery
            </h2>
          </div>
          <Link to="/shop" data-testid="shop-strip-view-all"
                className="flex items-center gap-1.5 rounded-full bg-navy px-4 py-2 text-xs font-bold text-white hover:bg-express">
            <ShoppingBag className="h-3.5 w-3.5" /> View Shop
          </Link>
        </div>
        <div className="space-y-3">
          {rows.map((row, i) => (
            <div key={i} className="flex gap-3 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid={`shop-strip-row-${i + 1}`}>
              {row.map((c) => <Card key={c.id} c={c} />)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
